// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21MUu","comment":"styles_comment__35Dd1"};